  <template>
  <div>
    <PageAllow controller="StockOrderAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 出库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="outDatetimeRange"
                type="datetime"
                show-radios
                :radios="timeSyncFlg ? DatetimeRadios : outDatetimeRadios"
                removeIcon
                switchIcon
                @switchAction="timeSyncFlg = !timeSyncFlg"
                :timeSyncFlg="timeSyncFlg"
              />
            </v-row>
            <!-- 入库时间 -->
            <v-row dense align="center" class="pa-1" v-if="!timeSyncFlg">
              <SearcherDatetimeRangeWithRadio
                v-model="inDatetimeRange"
                type="datetime"
                show-radios
                :radios="inDatetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 出入库单统计导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="chartexportExcel()"
                v-if="
                  $permission.permissionAllow('StockOrderAnalyze', 'export')
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.chartExcel") }}
              </v-btn>
              <!-- 导出出入库明细 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="exportExcel()"
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'detailExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.excel") }}
              </v-btn>
              <!-- 江西定制 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="exportExcelJX()"
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'detailJiangXiExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.excel") }}
              </v-btn>
              <!-- 导出出入库统计 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                href=""
                @click.stop="materialexportExcel()"
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'materialExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("inOutDetail.Export.materialExport") }}
              </v-btn>
              <!-- btn 统计表 -->
              <!-- <v-btn small color="print" dark class="ms-1" href="">
                {{ $t("stockOrderAnalyze.StatisticalTable") }}
              </v-btn> -->
              <!-- 导出 按钮 -->
              <!-- <v-btn small color="print" dark class="ms-1" href="">
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("stockOrderAnalyze.Export.excel") }}
              </v-btn> -->
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓库组别 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStockDistrict v-model="stockDistrictSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStock
                    v-model="stocksSelected"
                    :stock-district="stockDistrictSelected"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="options.stock_in_types"
                    clearable
                    :items="$consts.stock_in_order.types"
                    :label="$t('StockOrderIN.Fields.stock_in_type')"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="options.stock_out_types"
                    clearable
                    :items="$consts.stock_out_order.types"
                    :label="$t('StockOrderOUT.Fields.stock_out_type')"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                  >
                  </v-select>
                </v-col>
                <!-- 商品品牌 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherBrands
                    v-model="brandsSelected"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_order_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td colspan="3"></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ stock_order_in_total_num | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money")
                    }}{{ stock_order_in_total_price | formatTwoDot }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ stock_order_out_total_num | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ stock_order_out_total_price | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ stock_order_out_total_cost | formatMoney }}</span
                  >
                </td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("stockOrderAnalyze.Fields.in_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ stock_order_in_total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("stockOrderAnalyze.Fields.in_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ stock_order_in_total_price | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("stockOrderAnalyze.Fields.out_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ stock_order_out_total_num | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("stockOrderAnalyze.Fields.out_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ stock_order_out_total_price | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("stockOrderAnalyze.Fields.outCostPrice") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ stock_order_out_total_cost | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.material.material_code="{ item }">
              {{ item.material.material_code }}
            </template>
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                <span>
                  {{ item.material.material_name }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.name && item.name.length > 12" :title="item.name" style="cursor: pointer">
                    {{ item.name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.name }}
                  </span>
                </span>
              </span>
            </template>
            <!-- 按钮  -->
            <template v-slot:item.actions="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('StockOrderAnalyze', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/stock-order-analyze/' + item.material_id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("stockOrderAnalyze.edit.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("stockOrderAnalyze.edit.detail")])
                }}</span>
              </v-tooltip>
            </template>
            <!-- 入库数量格式化 -->
            <template v-slot:item.stockOrderIn="{ item }">
              {{ item.stockOrderIn | formatTwoDot }}
            </template>
            <!-- 入库金额合计 -->
            <template v-slot:item.stockOrderInPrice="{ item }">
              {{ $t("Global.money")
              }}{{ item.stockOrderInPrice | formatTwoDot }}
            </template>
            <!-- 出库数量 -->
            <template v-slot:item.stockOrderOut="{ item }">
              {{ item.stockOrderOut | formatTwoDot }}
            </template>
            <!-- 出库金额 -->
            <template v-slot:item.stockOrderOutPrice="{ item }">
              {{ $t("Global.money")
              }}{{ item.stockOrderOutPrice | formatMoney }}
            </template>
            <!-- 成本金额 -->
            <template v-slot:item.outCostPrice="{ item }">
              {{ $t("Global.money") }}{{ item.outCostPrice | formatMoney }}
            </template>
            <!-- 小计 -->
            <template v-slot:item.count_num="{ item }">
              {{ $t("Global.money")
              }}{{ (item.price * item.stock_current) | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import stockOrderAnalyze from "@/api/stock_order_analyze";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherBrands from "@/components/plugins/SearcherBrands";

const defaultOptions = {
  out_create_time_from: "",
  out_create_time_to: "",
  out_actual_time_from: "",
  out_actual_time_to: "",
  out_finish_time_from: "",
  out_finish_time_to: "",
  in_create_time_from: "",
  in_create_time_to: "",
  in_actual_time_from: "",
  in_actual_time_to: "",
  in_finish_time_from: "",
  in_finish_time_to: "",
  stock_districts: null,
  stock_id: null,
  category_codes: [],
  material_ids: [],
  stock_out_types: [],
  stock_in_types: [],
  brands: [],
};

const defaultOutDatetimeRange = {
  datetimeRadioSelected: "out_create",
  out_create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  out_create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  out_actual_time_from: "",
  out_actual_time_to: "",
  out_finish_time_from: "",
  out_finish_time_to: "",
  brands: [],
};
const defaultInDatetimeRange = {
  datetimeRadioSelected: "in_create",
  in_create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  in_create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  in_actual_time_from: "",
  in_actual_time_to: "",
  in_finish_time_from: "",
  in_finish_time_to: "",
  brands: [],
};

export default {
  name: "stockDetails",
  data: () => ({
    stock_order_analyze: [],
    stocksSelected: null,
    orderCodeKeyword: "",
    materialCategoriesSelected: [],
    materialSelected: null,
    stockDistrictSelected: null,
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stockIN-and-stockOUT-options")
        ? sessionStorage.getItem("stockIN-and-stockOUT-options")
        : JSON.stringify(defaultOptions)
    ),
    outDatetimeRange: JSON.parse(
      sessionStorage.getItem("stockIN-and-stockOUT-outDatetimeRange")
        ? sessionStorage.getItem("stockIN-and-stockOUT-outDatetimeRange")
        : JSON.stringify(defaultOutDatetimeRange)
    ),
    inDatetimeRange: JSON.parse(
      sessionStorage.getItem("stockIN-and-stockOUT-inDatetimeRange")
        ? sessionStorage.getItem("stockIN-and-stockOUT-inDatetimeRange")
        : JSON.stringify(defaultInDatetimeRange)
    ),
    loading: false,
    stock_order_in_total_num: 0,
    stock_order_in_total_price: 0,
    stock_order_out_total_num: 0,
    stock_order_out_total_price: 0,
    stock_order_out_total_cost: 0,
    timeSyncFlg: true,
    brandsSelected: [],
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterialCategoriesWithDescendants,
    SearcherStockDistrict,
    SearcherMaterials,
    SearcherStock,
    SearcherBrands,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stockOrderAnalyze"),
        disabled: true,
        href: "/stock-order-analyze",
      },
    ],
    outDatetimeRadios: () => [
      {
        key: "out_create",
        text: i18n.t("stockOrderAnalyze.Fields.out_created_time"),
      },
      {
        key: "out_actual",
        text: i18n.t("stockOrderAnalyze.Fields.out_actual_time"),
      },
      {
        key: "out_finish",
        text: i18n.t("stockOrderAnalyze.Fields.out_complete_time"),
      },
    ],
    DatetimeRadios: () => [
      {
        key: "out_create",
        text: i18n.t("stockOrderAnalyze.Fields.created_time"),
      },
      {
        key: "out_actual",
        text: i18n.t("stockOrderAnalyze.Fields.actual_time"),
      },
      {
        key: "out_finish",
        text: i18n.t("stockOrderAnalyze.Fields.complete_time"),
      },
    ],
    inDatetimeRadios: () => [
      {
        key: "in_create",
        text: i18n.t("stockOrderAnalyze.Fields.in_created_time"),
      },
      {
        key: "in_actual",
        text: i18n.t("stockOrderAnalyze.Fields.in_actual_time"),
      },
      {
        key: "in_finish",
        text: i18n.t("stockOrderAnalyze.Fields.in_complete_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("stockOrderAnalyze.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material.material_code",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.material"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.material_category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      // {
      //   text: i18n.t("stockOrderAnalyze.Fields.standard"),
      //   align: "start",
      //   sortable: false,
      //   value: "name",
      // },
      {
        text: i18n.t("stockOrderAnalyze.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      // 入库数量
      {
        text: i18n.t("stockOrderAnalyze.Fields.in_num"),
        align: "end",
        sortable: false,
        value: "stockOrderIn",
      },
      // 入库金额合计
      {
        text: i18n.t("stockOrderAnalyze.Fields.in_total"),
        align: "end",
        sortable: false,
        value: "stockOrderInPrice",
      },
      // 出库数量
      {
        text: i18n.t("stockOrderAnalyze.Fields.out_num"),
        align: "end",
        sortable: false,
        value: "stockOrderOut",
      },
      // 出库金额合计
      {
        text: i18n.t("stockOrderAnalyze.Fields.out_total"),
        align: "end",
        sortable: false,
        value: "stockOrderOutPrice",
      },
      // 成本金额合计
      {
        text: i18n.t("stockOrderAnalyze.Fields.outCostPrice"),
        align: "end",
        sortable: false,
        value: "outCostPrice",
      },
      // 操作
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stockIN-and-stockOUT", [
        "materialCategoriesSelected",
        "stockDistrictSelected",
        "materialSelected",
        "stocksSelected",
        "outDatetimeRange",
        "inDatetimeRange",
        "brandsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockDistrictSelected":
                this.stockDistrictSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "materialCategoriesSelected":
                this.materialCategoriesSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "outDatetimeRange":
                this.outDatetimeRange = selected.value;
                break;
              case "inDatetimeRange":
                this.inDatetimeRange = selected.value;
                break;
              case "brandsSelected":
                this.brandsSelected = selected.value;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stocksSelected = null;
      this.stockDistrictSelected = null;
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.brandsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.outDatetimeRange = JSON.parse(
        JSON.stringify(defaultOutDatetimeRange)
      );
      this.inDatetimeRange = JSON.parse(JSON.stringify(defaultInDatetimeRange));
    },
    getStockDetailsFromAPI() {
      this.loading = true;
      this.id = this.$route.query.stock_id;
      stockOrderAnalyze.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_order_analyze = response.data.stock_order_analyze;
            this.stock_order_in_total_num =
              response.data.stock_order_in_total_num;
            this.stock_order_in_total_price =
              response.data.stock_order_in_total_price;
            this.stock_order_out_total_num =
              response.data.stock_order_out_total_num;
            this.stock_order_out_total_price =
              response.data.stock_order_out_total_price;
            this.stock_order_out_total_cost =
              response.data.stock_order_out_total_cost;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      stockOrderAnalyze.exports(this.options);
    },
    exportExcelJX() {
      stockOrderAnalyze.detailJiangXiExport(this.options);
    },
    materialexportExcel() {
      stockOrderAnalyze.materialExport(this.options);
    },
    chartexportExcel() {
      stockOrderAnalyze.chartExports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockDetailsFromAPI();
        sessionStorage.setItem(
          "stockIN-and-stockOUT-options",
          JSON.stringify(this.options)
        );
      },
    },
    outDatetimeRange: {
      handler() {
        this.options.out_create_time_from =
          this.outDatetimeRange.out_create_time_from;
        this.options.out_create_time_to =
          this.outDatetimeRange.out_create_time_to;
        this.options.out_actual_time_from =
          this.outDatetimeRange.out_actual_time_from;
        this.options.out_actual_time_to =
          this.outDatetimeRange.out_actual_time_to;
        this.options.out_finish_time_from =
          this.outDatetimeRange.out_finish_time_from;
        this.options.out_finish_time_to =
          this.outDatetimeRange.out_finish_time_to;
        if (this.timeSyncFlg) {
          this.inDatetimeRange.in_create_time_from =
            this.outDatetimeRange.out_create_time_from;
          this.inDatetimeRange.in_create_time_to =
            this.outDatetimeRange.out_create_time_to;
          this.inDatetimeRange.in_actual_time_from =
            this.outDatetimeRange.out_actual_time_from;
          this.inDatetimeRange.in_actual_time_to =
            this.outDatetimeRange.out_actual_time_to;
          this.inDatetimeRange.in_finish_time_from =
            this.outDatetimeRange.out_finish_time_from;
          this.inDatetimeRange.in_finish_time_to =
            this.outDatetimeRange.out_finish_time_to;
          if (this.outDatetimeRange.datetimeRadioSelected == "out_create")
            this.inDatetimeRange.datetimeRadioSelected = "in_create";
          if (this.outDatetimeRange.datetimeRadioSelected == "out_actual")
            this.inDatetimeRange.datetimeRadioSelected = "in_actual";
          if (this.outDatetimeRange.datetimeRadioSelected == "out_finish")
            this.inDatetimeRange.datetimeRadioSelected = "in_finish";
        }
        sessionStorage.setItem(
          "stockIN-and-stockOUT-outDatetimeRange",
          JSON.stringify(this.outDatetimeRange)
        );
      },
    },
    inDatetimeRange: {
      deep: true,
      handler() {
        this.options.in_create_time_from =
          this.inDatetimeRange.in_create_time_from;
        this.options.in_create_time_to = this.inDatetimeRange.in_create_time_to;
        this.options.in_actual_time_from =
          this.inDatetimeRange.in_actual_time_from;
        this.options.in_actual_time_to = this.inDatetimeRange.in_actual_time_to;
        this.options.in_finish_time_from =
          this.inDatetimeRange.in_finish_time_from;
        this.options.in_finish_time_to = this.inDatetimeRange.in_finish_time_to;
        sessionStorage.setItem(
          "stockIN-and-stockOUT-inDatetimeRange",
          JSON.stringify(this.inDatetimeRange)
        );
      },
    },

    // 仓库组别
    stockDistrictSelected: {
      handler() {
        this.options.stock_districts = this.stockDistrictSelected
          ? this.stockDistrictSelected.code
          : null;
        sessionStorage.setItem(
          "stockIN-and-stockOUT-stockDistrictSelected",
          JSON.stringify(this.stockDistrictSelected)
        );
      },
    },
    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_id = this.stocksSelected
          ? this.stocksSelected.id
          : null;
        sessionStorage.setItem(
          "stockIN-and-stockOUT-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : "";
        sessionStorage.setItem(
          "stockIN-and-stockOUT-materialCategoriesSelected",
          JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stockIN-and-stockOUT-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 商品品牌
    brandsSelected: {
      handler() {
        this.options.brands = this.brandsSelected
          ? this.brandsSelected.map((e) => {
              return e;
            })
          : "";
        sessionStorage.setItem(
          "stockIN-and-stockOUT-brandsSelected",
          JSON.stringify(this.brandsSelected)
        );
      },
    },
    timeSyncFlg: {
      immediate: true,
      handler() {
        this.outDatetimeRange = Object.assign({}, this.outDatetimeRange);
        this.inDatetimeRange = Object.assign({}, this.inDatetimeRange);
        sessionStorage.setItem(
          "stockIN-and-stockOUT-timeSyncFlg",
          JSON.stringify(this.timeSyncFlg)
        );
      },
    },
  },
};
</script>